export default {"src":"/_next/static/media/white-floorplan-tour.7e9d35e5.svg","height":17,"width":21,"blurWidth":0,"blurHeight":0};